//@flow
import React from 'react';
import Link from '../../../components/Link';

const config = {
  title: 'Office Variety Box',
  subtitle: 'We deliver a box of seven bulk-sized office snack packages along with everything you need to set up. Perfect for 10-30 people.',
  cards: [
    {
      title: 'You pick',
      count: '3',
      description: 'Staple snacks from our base catalog to receive every month.',
    },
    {
      title: 'We pick',
      count: '4',
      description: 'That change every month to match your tastes and keep your selection fresh',
      className: 'card-yellow-border',
    },
  ],
};

const {title, subtitle, cards} = config;

const OfficeVarietyBox = (props:any) => {
  return (
    <div className="office-variety-box">
      <div className="top">
        <h2>{title}</h2>
        <div className="subtitle">
          {subtitle}
        </div>
      </div>
      <div className="plan-cards">
        <Card {...cards[0]} />
        <div className="plus">+</div>
        <Card {...cards[1]} />
      </div>
      <div className="bottom">
        <Link to="/office#office-form">
          <button className="cta button">
            Learn More
          </button>
        </Link>
      </div>
    </div>
  );
};

const Card = (props) => {
  return (
    <div className={`card ${props.className || ''}`}>
      <div className="card-title">{props.title}</div>
      <div className="card-count">{props.count}</div>
      <div className="card-description">{props.description}</div>
    </div>
  );
};

export default OfficeVarietyBox;
